import React, { useState } from 'react';
import { Box, Button, FormControl, FormLabel, Input, Select, useToast } from '@chakra-ui/react';
import { UseDispatch,useDispatch,useSelector } from 'react-redux';
import 'toastr/build/toastr.min.css';
import toastr from 'toastr'
import { createJobPost} from './redux/postslice'
export default function CreateJob() {
  const [job, setJob] = useState({
    jobTitle: '',
    companyName: '',
    companyLogo: undefined,
    numberOfEmployees: '',
    servicesOffered: '',
    experienceRequired: 'Full Time',
    jobType: 'Remote',
    jobDescription: ''
  });

  const toast = useToast();
const dispatch=useDispatch()
  const handleChange = (e) => {
    const { name, value } = e.target;
    setJob(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    console.log(e.target.files[0])
    const reader = new FileReader();
    setJob(prevState => ({
      ...prevState,
      companyLogo:e.target.files[0]
    }));
    // reader.onloadend = () => {
    //   setJob(prevState => ({
    //     ...prevState,
    //     companyLogo: reader.result
    //   }));
    // };

    // if (file) {
    //   reader.readAsDataURL(file);
    // }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log(job)
    let form=new FormData();
    form.append('jobTitle',job.jobTitle)
  form.append('companyName',job.companyName)
   form.append('image',job.companyLogo)
   form.append('numberOfEmployees',job.numberOfEmployees)
    form.append('servicesOffered',job.servicesOffered)
    form.append('experienceRequired',job.experienceRequired)
form.append('jobType',job.jobType)
form.append('jobDescription',job.jobDescription)
  
    let createjobPostRes=await dispatch(createJobPost(form))
    if(createJobPost.rejected.match(createjobPostRes)){
      console.log('rejected')
console.log(createjobPostRes)
toast({
  title: createjobPostRes?.payload?.error,
  status: 'error',
  duration: 3000,
  isClosable: true,
});
    }

    if(createJobPost.fulfilled.match(createjobPostRes)){
      setJob({
        jobTitle: '',
        companyName: '',
        companyLogo: '',
        numberOfEmployees: '',
        servicesOffered: '',
        experienceRequired: 'Full Time',
        jobType: 'Remote',
        jobDescription: ''
      })
          toast({
        title: 'Job created successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    }
   
  };

  return (
    <Box
      p={8}
      borderRadius="lg"
      boxShadow="md"
      maxWidth="1040px"
      margin="auto"
     
    >
      <form onSubmit={handleSubmit}>
        <FormControl>
          <FormLabel>Job Title</FormLabel>
          <Input name="jobTitle" value={job.jobTitle} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Company Name</FormLabel>
          <Input name="companyName" value={job.companyName} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Company Logo</FormLabel>
          <Input type="file" accept="image/png, image/jpeg" onChange={handleLogoChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Number of Employees</FormLabel>
          <Input name="numberOfEmployees" type="number" value={job.numberOfEmployees} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Services Offered</FormLabel>
          <Input name="servicesOffered" value={job.servicesOffered} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Experience Required</FormLabel>
          <Select name="experienceRequired" value={job.experienceRequired} onChange={handleChange}>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Job Type</FormLabel>
          <Select name="jobType" value={job.jobType} onChange={handleChange}>
            <option value="Remote">Remote</option>
            <option value="Hybrid">Hybrid</option>
            <option value="Onsite">Onsite</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Job Description</FormLabel>
          <Input name="jobDescription" value={job.jobDescription} onChange={handleChange} />
        </FormControl>
        <Button mt={4} colorScheme="teal" type="submit" width="100%">Create</Button>
      </form>
    </Box>
  );
}
